// extracted by mini-css-extract-plugin
export default {"bannerPage":"BannerPage_bannerPage__cPA4K","banner":"BannerPage_banner__PKvH9"};